<template>
    <div>
        <template v-if="summary">
            <v-row>
                <v-col cols="8">
                    <StepHeader
                        :subtitle="$t('habiteoStudio.remind')"
                        :description="$t('habiteoStudio.userOptionSelected')"
                    />
                </v-col>
                <v-col cols="4">
                    <v-img
                        :src="illustration"
                        contain
                        :aspect-ratio="2"
                    />
                </v-col>
            </v-row>
            <div
                v-for="(step, stepIndex) in stepList"
                :key="`step-${stepIndex}`"
            >
                <div
                    v-for="(form, formIndex) in step.forms"
                    :key="`form-${stepIndex}-${formIndex}`"
                    v-show="form.id !== 'color'"
                >
                    <StepConfiguration
                        :title="step.id === 'step_3' && form.id ==='preset' ? form.title : step.subtitle"
                        :form="form"
                        :selectedValue="selectedValues[form.id]"
                        :stepIndex="stepIndex"
                        @select-step="gotToStep"
                    />
                </div>
            </div>
        </template>
        <template v-else>
            <StepHeader
                :subtitle="step.subtitle"
                :description="step.description"
            />
            <div class="d-flex flex-wrap flex-column">
                <div
                    class="pa-2 input-file"
                    style="width: 100%;"
                >
                    <v-text-field
                        filled
                        v-model="defaultFilename"
                        :rules="[() => (!!defaultFilename) || $t('habiteoStudio.mandatoryField')]"
                        :label="'Nom du fichier'"
                        :placeholder="step.forms[0].inputs[0].fields[0].placeholder"
                    />
                    <div class="export-file-extension">
                        {{ step.forms[0].inputs[0].fields[0].extension }}
                    </div>
                </div>
                <v-row
                    dense
                    no-gutters
                    class="pb-4"
                >
                    <h3 class="green-text text-darken-1 text-center">
                        {{ $t('habiteoStudio.instructions') }}
                    </h3>
                </v-row>
            </div>
        </template>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';

    import StepHeader from '@/components/myHabiteoStudio/steps/components/StepHeader';
    import StepConfiguration from '@/components/myHabiteoStudio/steps/components/StepConfiguration';

    export default {
        name: 'StepExport',
        components: {
            StepHeader,
            StepConfiguration
        },
        props: {
            step: {
                type: Object,
                required: true
            },
            steps: {
                type: Array,
                required: true
            },
            selectedValues: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                summary: true,
                filename: '',
                illustration: null
            }
        },
        computed: {
            stepList() {
                return this.$props.steps ? this.$props.steps.filter(step => step.id !== 'step_5') : null;
            },
            mediaType() {
                return this.$props.steps && this.$props.steps.find(step => step.id === 'step_1')? this.$props.steps.find(step => step.id === 'step_1').forms[0].inputs[0].fields.find(field => this.$props.selectedValues.media === field.value).label.replace(/ /g, "") : null;
            },
            format() {
                return this.$props.steps && this.$props.steps.find(step => step.id === 'step_2') ? this.$props.steps.find(step => step.id === 'step_2').forms[0].inputs[0].fields.find(field => this.$props.selectedValues.format === field.value).label.replace(/ /g, "") : null;
            },
            quality() {
                return this.$props.steps && this.$props.steps.find(step => step.id === 'step_3') ? this.$props.steps.find(step => step.id === 'step_3').forms[1].inputs[0].fields.find(field => this.$props.selectedValues.quality === field.value).label.replace(/ /g, "") : null;
            },
            defaultFilename: {
                get () {
                    return this.filename ? this.filename : '';
                },
                set (val) {
                    this.filename = val
                }
            }
        },
        mounted() {
            EventBus.$on('submit-summary', () => {
                this.summary = false;
            });

            EventBus.$on('display-summary', () => {
                this.summary = true;
            })

            this.filename = this.format && this.quality ?  this.mediaType.toLowerCase() + '_' + this.format.replace('/', '_').toLowerCase() + '_' + this.quality.toLowerCase() : this.mediaType.toLowerCase();
        },
        methods: {
            gotToStep(step) {
                EventBus.$emit('update-step');
                this.$emit('select-step', step);
            }
        },
        watch: {
            step() {
                if (this.$props.step !== 'step_5')
                    this.summary = true;
            },
            filename(name) {
                this.$props.step.forms[0].inputs[0].value = name.trim();
                EventBus.$emit('setFilename', name.trim());
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/StepExport.vue